import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(Authentication)/login/page.tsx");
